import request from '../../utils/request';

export const getTechnologiesService = (value = '') => {
  return async dispatch => {
    const response = await dispatch(
      request('/specifications/technologies', {
        method: 'GET',
        params: { value },
      }),
    );
    return response;
  };
};

export const saveTechnologyService = (data, id = 0) => {
  if (id > 0) {
    return async dispatch => {
      const response = await dispatch(
        request('/specifications/technologies/' + id, {
          method: 'PUT',
          data,
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/specifications/technologies', {
        method: 'POST',
        data,
      }),
    );
    return response;
  };
};

export const deleteTechnologiesService = array => {
  return async dispatch => {
    const response = await dispatch(
      request('/specifications/technologies', {
        method: 'DELETE',
        params: { id: array },
      }),
    );
    return response;
  };
};
